import React from 'react';
import { useNavigation } from '../context/NavigationContext';
export function Footer() {
  const {
    navigate
  } = useNavigation();
  return <footer className="bg-charcoal text-cream/60 py-12 px-6 text-center text-sm" data-id="element-41">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-42">
        <p data-id="element-43">© {new Date().getFullYear()} El Mapa de Pago en 10 Min.</p>
        <div className="flex justify-center gap-6" data-id="element-44">
          <button onClick={() => navigate('terms')} className="hover:text-cream transition-colors bg-transparent border-none cursor-pointer" data-id="element-45">
            Términos
          </button>
          <button onClick={() => navigate('privacy')} className="hover:text-cream transition-colors bg-transparent border-none cursor-pointer" data-id="element-46">
            Privacidad
          </button>
        </div>
        <p className="text-xs max-w-md mx-auto opacity-50" data-id="element-47">
          Este producto es una herramienta educativa. No constituye
          asesoramiento financiero profesional.
        </p>
      </div>
    </footer>;
}